// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__28pSf","footer":"ModalUpdate_footer__3gmtU"};